export default "__VITE_ASSET__BPMnsy2h__"